import { render, staticRenderFns } from "./actPlaceRule.vue?vue&type=template&id=cc1f16b6"
import script from "./actPlaceRule.vue?vue&type=script&lang=js"
export * from "./actPlaceRule.vue?vue&type=script&lang=js"
import style0 from "./actPlaceRule.vue?vue&type=style&index=0&id=cc1f16b6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports